import React, { FunctionComponent, Suspense } from "react";

const DotLottieReact = React.lazy(() =>
  import("@lottiefiles/dotlottie-react").then((m) => ({
    default: m.DotLottieReact,
  })),
);

export const SuccessAnimation: FunctionComponent = () => {
  return (
    <Suspense fallback={null}>
      <DotLottieReact src="/animations/success.lottie" autoplay segment={[0, 51]} />
    </Suspense>
  );
};
